<template>
  <div class="page-content">
    <page-template
      ref="situation"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>
<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from "@/config/api";

export default {
  components: {
    pageTemplate
  },
  data() {
    return {
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [],
        complex: [
          {label: "选择日期", prop: "CreateDttm", type: "dateTimeRangeButton", dateType: "datetime", span: 24},
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            span: 8,
            isHasAll: true,
            data: [],
            url: api.system.seStore,
            // defaultValue:this.$utils.getSysUser().storeId?this.$utils.getSysUser().storeId:-1
          },
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: "查询",
        },
        {
          label: "打印",
        },
        {
          label: "导出",
          code: 'export',
          callback: this.exportExcel
        },
      ],
      // 表格信息配置
      tableOptions: {
        showSummary: true,
        summaryColumns: ['totalMoney', 'cashierMoney', 'dbyMoney', 'weChatMoney', 'aliMoney', 'vipMoney', 'bankCardMoney', 'programMoney', 'otherMoney'],
        columns: [
          {
            label: "类型名称",
            prop: "typeName",
            width: "90",
            align: "center"
          },
          {
            label: "概况",
            prop: "orderCount",
            width: "240",
            align: "center",
            deal: this.optionsInfo
            // type:'pinjieInfo',
            // dealInfo: [
            //   {label:"单数",prop:'orderCount'},
            //   {label:"销售额",prop:'totalMoney'},
            //   {label:"赠送额",prop:'discountPrice'},
            // ]
          },
          {label: "合计", prop: "totalMoney", width: "120", align: "center"},
          {
            label: "现金",
            prop: "cashierMoney",
            width: "120",
            align: "center"
          },
          {
            label: '店播支付',
            prop: 'dbyMoney',
            width: '150',
            align: 'center'
          },
          // {
          //   label: "微信",
          //   prop: "weChatMoney",
          //   width: "120",
          //   align: "center",
          // },
          // {
          //   label: "支付宝",
          //   prop: "aliMoney",
          //   width: "120",
          //   align: "center",
          // },
          {
            label: "会员卡",
            prop: "vipMoney",
            width: "120",
            align: "center",
          },
          // {
          //   label: "银行卡",
          //   prop: "bankCardMoney",
          //   width: "120",
          //   align: "center",
          // },
          // {
          //   label: "小程序",
          //   prop: "programMoney",
          //   width: "120",
          //   align: "center",
          // },
          {
            label: "其他支付",
            prop: "otherMoney",
            width: "120",
            align: "center",
          },
        ],
        param: {
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        },
        url: api.member.businessOverview,
      },
    };
  },
  mounted() {
  },
  methods: {
    optionsInfo(row) {
      return `<span>单数:${row.orderCount}---销售额:${row.totalMoney}---赠送额:${row.discountPrice}</span>`
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = this.$refs['situation'].$refs['tableTemp'].searchParam;
      this.$axios.PostBlob(api.member.businessOverviewExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '营业概况_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/page/retail/query/business/Situation.vue